/* ============================================================
   PICK YOUR VIBE — CARD MODULE
   ============================================================ */
(function () {
  'use strict';

  /* ============================================================
     CARD GRADIENTS
  ============================================================ */
  var CARD_GRADIENTS = [
    'linear-gradient(148deg, #E6C97A 0%, #C9A14A 100%)',
    'linear-gradient(128deg, #EDD880 0%, #CC9E38 100%)',
    'linear-gradient(162deg, #F0D878 0%, #D4A030 100%)',
    'linear-gradient(140deg, #DAB95C 0%, #BA8228 100%)',
    'linear-gradient(118deg, #EAC86A 0%, #C89240 100%)',
    'linear-gradient(155deg, #F3DC92 0%, #CDA03A 100%)',
    'linear-gradient(136deg, #E2C060 0%, #C08830 100%)',
    'linear-gradient(144deg, #F5E4A0 0%, #D4AA48 100%)',
    'linear-gradient(148deg, #E8D4F0 0%, #C4A0D8 100%)',
    'linear-gradient(128deg, #EDD8F9 0%, #C8A8E0 100%)',
    'linear-gradient(162deg, #E0CCE8 0%, #BC98D0 100%)',
    'linear-gradient(140deg, #F0DEFA 0%, #CCB0E4 100%)',
    'linear-gradient(118deg, #D8C6EA 0%, #B88EC8 100%)',
    'linear-gradient(155deg, #ECDCF8 0%, #C4A0DC 100%)',
    'linear-gradient(136deg, #E6CCF0 0%, #C298D4 100%)',
    'linear-gradient(150deg, #D4BEE8 0%, #A87EC0 100%)',
    'linear-gradient(145deg, #F2D4D8 0%, #D8A0A8 100%)',
    'linear-gradient(130deg, #EEC8CC 0%, #CC8890 100%)',
    'linear-gradient(160deg, #F8E0E4 0%, #E0A8B0 100%)',
    'linear-gradient(140deg, #E8C0C8 0%, #C88890 100%)',
    'linear-gradient(155deg, #F4D8DC 0%, #D4A0A8 100%)',
    'linear-gradient(125deg, #F0C8D0 0%, #D09098 100%)',
    'linear-gradient(148deg, #C8D8C0 0%, #94B088 100%)',
    'linear-gradient(135deg, #D4E0CC 0%, #A0BC94 100%)',
    'linear-gradient(158deg, #BED0B8 0%, #88A880 100%)',
    'linear-gradient(142deg, #CCDCC4 0%, #98B48C 100%)',
    'linear-gradient(120deg, #D8E8D0 0%, #ACC8A0 100%)',
    'linear-gradient(145deg, #E8C4B0 0%, #C8906C 100%)',
    'linear-gradient(132deg, #F0CEC0 0%, #D8A084 100%)',
    'linear-gradient(158deg, #DEB8A4 0%, #BC8464 100%)',
    'linear-gradient(140deg, #ECC8B8 0%, #CC9878 100%)',
    'linear-gradient(148deg, #C4D0DC 0%, #8CA0B4 100%)',
    'linear-gradient(135deg, #D0D8E4 0%, #98ACBC 100%)',
    'linear-gradient(162deg, #B8C8D8 0%, #8098AC 100%)',
    'linear-gradient(140deg, #C8D4E0 0%, #90A4B4 100%)',
    'linear-gradient(145deg, #F0E8D8 0%, #D8C8A8 100%)',
    'linear-gradient(130deg, #ECE4D4 0%, #D4C0A0 100%)',
    'linear-gradient(158deg, #F4ECD8 0%, #DCCCA8 100%)',
    'linear-gradient(138deg, #EEE4D0 0%, #D6C4A0 100%)',
    'linear-gradient(148deg, #F0C8B8 0%, #D89880 100%)',
    'linear-gradient(135deg, #ECC4B4 0%, #CC9070 100%)',
    'linear-gradient(145deg, #DCC8D8 0%, #B498B4 100%)',
    'linear-gradient(132deg, #E4D0E0 0%, #C0A0BC 100%)',
    'linear-gradient(148deg, #C0D4D4 0%, #88B0B0 100%)',
    'linear-gradient(136deg, #C8DCDC 0%, #94B8B8 100%)'
  ];

  var STAR_PATH = 'M6.24238 1.24323C6.26612 1.19527 6.30279 1.1549 6.34825 1.12668C6.39371 1.09845 6.44616 1.0835 6.49967 1.0835C6.55318 1.0835 6.60563 1.09845 6.65109 1.12668C6.69656 1.1549 6.73323 1.19527 6.75696 1.24323L8.00821 3.77769C8.09064 3.9445 8.21232 4.08883 8.3628 4.19827C8.51328 4.30771 8.68808 4.379 8.87217 4.40602L11.6704 4.81552C11.7234 4.8232 11.7733 4.84557 11.8142 4.88009C11.8552 4.91461 11.8857 4.9599 11.9023 5.01085C11.9188 5.0618 11.9208 5.11637 11.908 5.16838C11.8952 5.2204 11.868 5.26779 11.8297 5.30519L9.80601 7.27577C9.67255 7.40583 9.57269 7.56637 9.51504 7.74357C9.45739 7.92077 9.44366 8.10934 9.47505 8.29302L9.9528 11.0772C9.96216 11.1302 9.95643 11.1847 9.93628 11.2346C9.91612 11.2845 9.88234 11.3278 9.8388 11.3594C9.79526 11.391 9.7437 11.4098 9.69002 11.4135C9.63633 11.4172 9.58268 11.4058 9.53517 11.3805L7.03376 10.0654C6.86894 9.97881 6.68556 9.93359 6.4994 9.93359C6.31324 9.93359 6.12987 9.97881 5.96505 10.0654L3.46417 11.3805C3.41669 11.4057 3.3631 11.417 3.3095 11.4132C3.2559 11.4093 3.20445 11.3906 3.161 11.359C3.11755 11.3274 3.08383 11.2842 3.06369 11.2344C3.04356 11.1846 3.0378 11.1301 3.04709 11.0772L3.5243 8.29356C3.55582 8.10979 3.54216 7.92111 3.48451 7.7438C3.42685 7.56648 3.32692 7.40586 3.19334 7.27577L1.16967 5.30573C1.13099 5.26837 1.10359 5.2209 1.09057 5.16873C1.07755 5.11655 1.07945 5.06177 1.09605 5.01062C1.11265 4.95948 1.14328 4.91402 1.18445 4.87943C1.22562 4.84484 1.27568 4.82251 1.32892 4.81498L4.12663 4.40602C4.31094 4.37921 4.48597 4.30801 4.63666 4.19856C4.78734 4.0891 4.90918 3.94467 4.99167 3.77769L6.24238 1.24323Z';

  var STAR_FULL = '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="display:inline-block;flex-shrink:0">' +
    '<path d="' + STAR_PATH + '" fill="#F59E0B" stroke="#F59E0B" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var STAR_HALF = '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="display:inline-block;flex-shrink:0">' +
    '<defs><clipPath id="pyv-half-l"><rect x="0" y="0" width="6.5" height="13"/></clipPath><clipPath id="pyv-half-r"><rect x="6.5" y="0" width="6.5" height="13"/></clipPath></defs>' +
    '<path d="' + STAR_PATH + '" fill="#F59E0B" stroke="#F59E0B" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round" clip-path="url(#pyv-half-l)"/>' +
    '<path d="' + STAR_PATH + '" fill="none" stroke="#F59E0B" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round" opacity="0.4" clip-path="url(#pyv-half-r)"/>' +
    '</svg>';

  var STAR_EMPTY_SVG = '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="display:inline-block;flex-shrink:0">' +
    '<path d="' + STAR_PATH + '" fill="none" stroke="#F59E0B" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/>' +
    '</svg>';

  /* Arrow-out-of-box glyph — shared by the desktop panel button (rendered in
     Liquid) and the mobile card info bar button (rendered here). Keep the two
     in sync if the path ever changes. */
  var VIEW_PRODUCT_ICON_SVG = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M6.5 3H3.8C3.36 3 3 3.36 3 3.8V12.2C3 12.64 3.36 13 3.8 13H12.2C12.64 13 13 12.64 13 12.2V9.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M9.5 3H13V6.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M13 3L7.5 8.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function buildStarsHTML(score) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      if (score >= i) html += STAR_FULL;
      else if (score >= i - 0.5) html += STAR_HALF;
      else html += STAR_EMPTY_SVG;
    }
    return html;
  }

  if (!window.PYVRyviuCache) window.PYVRyviuCache = {};

  var COLOR_MAP = {
    'black': '#1a1a1a', 'white': '#ffffff', 'ivory': '#fffff0', 'cream': '#f5ebd8',
    'beige': '#f0d8a8', 'nude': '#e6c9a8', 'tan': '#c89a5e', 'brown': '#7a4a26',
    'chocolate': '#4a2a18', 'camel': '#c19a6b', 'taupe': '#b8a791', 'grey': '#888888',
    'gray': '#888888', 'silver': '#c0c0c0', 'gold': '#d4af37', 'rose gold': '#e8b4a8',
    'rose-gold': '#e8b4a8', 'red': '#d8302a', 'maroon': '#7a1f1f', 'burgundy': '#6b1f29',
    'wine': '#7a223a', 'pink': '#f4a8c0', 'hot pink': '#ff5c8a', 'baby pink': '#fbd4dc',
    'blush': '#f0c8c0', 'fuchsia': '#d63384', 'magenta': '#b9168c', 'orange': '#f08030',
    'peach': '#fbb88a', 'coral': '#f08070', 'yellow': '#f5d040', 'mustard': '#c8a020',
    'green': '#3a8050', 'olive': '#6b7030', 'lime': '#a8d030', 'mint': '#a8e0c0',
    'teal': '#1a8a90', 'turquoise': '#3ac0c0', 'blue': '#3a6dc0', 'navy': '#1a2850',
    'royal blue': '#2050c0', 'sky blue': '#a8d0e8', 'baby blue': '#c0d8e8',
    'light blue': '#a8c8e0', 'dark blue': '#1a3870', 'purple': '#7a3098',
    'violet': '#9a50c0', 'lavender': '#c8a8d8', 'lilac': '#c8b0e0',
    'multi': 'linear-gradient(135deg, #f08070 0%, #f5d040 33%, #3a8050 66%, #3a6dc0 100%)',
    'multicolor': 'linear-gradient(135deg, #f08070 0%, #f5d040 33%, #3a8050 66%, #3a6dc0 100%)'
  };

  function colorNameToCss(name) {
    if (!name) return '#cccccc';
    var raw = String(name).trim();
    var key = raw.toLowerCase();
    if (COLOR_MAP.hasOwnProperty(key)) return COLOR_MAP[key];
    if (/^#[0-9a-f]{3,8}$/i.test(raw)) return raw;
    if (/^(rgb|hsl)a?\(/i.test(raw)) return raw;
    return '#cccccc';
  }

  function escHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getCardGradient(product) {
    var id = String(product.id);
    var h = 0;
    for (var i = 0; i < id.length; i++) { h = (h * 31 + id.charCodeAt(i)) | 0; }
    return CARD_GRADIENTS[Math.abs(h) % CARD_GRADIENTS.length];
  }

  function getSelectedVariant(product) {
    if (!product.variants || !product.variants.length) return null;
    var idx = product.selectedVariantIdx !== undefined ? product.selectedVariantIdx : 0;
    return product.variants[idx] || product.variants[0];
  }

  function getUniqueSizeVariants(product) {
    var seen = {}, result = [];
    (product.variants || []).forEach(function (v, idx) {
      var key = String(v.size || '').trim();
      if (!key) return;
      if (!seen.hasOwnProperty(key)) {
        seen[key] = result.length;
        result.push({ size: key, idx: idx, available: v.available, price: v.price, id: v.id });
      } else if (v.available && !result[seen[key]].available) {
        var e = result[seen[key]]; e.available = true; e.idx = idx; e.id = v.id; e.price = v.price;
      }
    });
    return result;
  }

  function getUniqueColorVariants(product) {
    var seen = {}, result = [];
    (product.variants || []).forEach(function (v, idx) {
      var raw = (v.color != null ? String(v.color) : '').trim();
      if (!raw) return;
      var key = raw.toLowerCase();
      if (!seen.hasOwnProperty(key)) {
        seen[key] = result.length;
        result.push({ color: raw, idx: idx, available: !!v.available, price: v.price, id: v.id });
      } else if (v.available && !result[seen[key]].available) {
        var e = result[seen[key]]; e.available = true; e.idx = idx; e.id = v.id; e.price = v.price;
      }
    });
    return result;
  }

  function findVariantIndex(product, targetSize, targetColor) {
    var variants = product.variants || [];
    var availableExact = -1, anyExact = -1, availableSize = -1, anySize = -1;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var sizeMatch = targetSize == null || String(v.size || '') === String(targetSize);
      var colorMatch = targetColor == null || String(v.color || '').toLowerCase() === String(targetColor).toLowerCase();
      if (sizeMatch && colorMatch) { if (v.available && availableExact < 0) availableExact = i; if (anyExact < 0) anyExact = i; }
      if (sizeMatch) { if (v.available && availableSize < 0) availableSize = i; if (anySize < 0) anySize = i; }
    }
    if (availableExact >= 0) return availableExact;
    if (anyExact >= 0) return anyExact;
    if (availableSize >= 0) return availableSize;
    if (anySize >= 0) return anySize;
    return -1;
  }

  function renderSizePills(product, container, onChange) {
    container.innerHTML = '';
    var sizes = getUniqueSizeVariants(product);
    if (!sizes.length) return;
    var currentIdx = product.selectedVariantIdx !== undefined ? product.selectedVariantIdx : 0;
    var activeUniqueIdx = 0;
    sizes.forEach(function (s, ui) { if (s.idx === currentIdx) activeUniqueIdx = ui; });
    sizes.forEach(function (s, ui) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'pyv-size-pill'; btn.textContent = s.size;
      if (!s.available) { btn.classList.add('is-unavailable'); btn.disabled = true; btn.setAttribute('aria-label', s.size + ' — sold out'); }
      else { btn.setAttribute('aria-label', s.size); }
      if (ui === activeUniqueIdx) btn.classList.add('is-selected');
      if (s.available) {
        btn.addEventListener('click', function () {
          product.selectedVariantIdx = s.idx;
          container.querySelectorAll('.pyv-size-pill').forEach(function (p) { p.classList.toggle('is-selected', p === btn); });
          if (typeof onChange === 'function') onChange(s, product);
        });
      }
      container.appendChild(btn);
    });
  }

  function buildMobileInfoBarHTML(product, opts) {
    opts = opts || {};
    var sizeLabel = opts.sizeLabel || 'Size';
    var sizeGuideText = opts.sizeGuideText || 'Size Guide';
    var sizeGuideUrl = opts.sizeGuideUrl || '';
    var showViewProduct = opts.showViewProduct !== false;
    var viewProductText = opts.viewProductText || 'View product';
    var viewProductNewTab = opts.viewProductNewTab !== false;
    var sv = getSelectedVariant(product);
    var colors = getUniqueColorVariants(product);
    var sizes = getUniqueSizeVariants(product);
    var currentIdx = product.selectedVariantIdx !== undefined ? product.selectedVariantIdx : 0;

    var activeColorUniqueIdx = -1;
    colors.forEach(function (c, ui) { if (c.idx === currentIdx) activeColorUniqueIdx = ui; });
    if (activeColorUniqueIdx < 0 && sv && sv.color) {
      var ck = String(sv.color).toLowerCase();
      colors.forEach(function (c, ui) { if (String(c.color).toLowerCase() === ck) activeColorUniqueIdx = ui; });
    }

    var swatchesHTML = colors.length ? colors.map(function (c, ui) {
      var cls = 'pyv-color-swatch' + (ui === activeColorUniqueIdx ? ' is-selected' : '') + (!c.available ? ' is-unavailable' : '');
      var bg = colorNameToCss(c.color);
      var styleProp = bg.indexOf('gradient') >= 0 ? 'background-image: ' + bg + ';' : 'background-color: ' + bg + ';';
      return '<button type="button" class="' + cls + '" data-color-name="' + escHtml(c.color) + '" data-color-idx="' + c.idx + '" style="' + styleProp + '" title="' + escHtml(c.color) + '" aria-label="' + escHtml(c.color) + '"' + (!c.available ? ' disabled' : '') + '></button>';
    }).join('') : '<span class="pyv-mobile-swatches-none" aria-hidden="true"></span>';

    var activeSizeUniqueIdx = -1;
    sizes.forEach(function (s, ui) { if (s.idx === currentIdx) activeSizeUniqueIdx = ui; });
    if (activeSizeUniqueIdx < 0 && sv && sv.size) {
      var cs2 = String(sv.size);
      sizes.forEach(function (s, ui) { if (String(s.size) === cs2) activeSizeUniqueIdx = ui; });
    }

    var sizePillsHTML = sizes.length ? sizes.map(function (s, ui) {
      var cls = 'pyv-size-pill' + (ui === activeSizeUniqueIdx ? ' is-selected' : '') + (!s.available ? ' is-unavailable' : '');
      return '<button type="button" class="' + cls + '" data-size-value="' + escHtml(s.size) + '" data-size-idx="' + s.idx + '"' + (!s.available ? ' disabled' : '') + '>' + escHtml(s.size) + '</button>';
    }).join('') : '';

    var sizeGuideHTML = sizeGuideUrl
      ? '<a class="pyv-mobile-size-guide" href="' + escHtml(sizeGuideUrl) + '"><span class="pyv-mobile-size-guide-text">' + escHtml(sizeGuideText) + '</span><span class="pyv-mobile-size-guide-icon" aria-hidden="true">↗</span></a>'
      : '<span class="pyv-mobile-size-guide-placeholder" aria-hidden="true"></span>';

    /* View product icon button — sits immediately right of the price, inside
       .pyv-mobile-price-group so swatches keep their hard-right alignment.
       Marked data-pyv-mobile-view-product so the drag handler ignores it. */
    var viewProductHTML = (showViewProduct && product.url)
      ? '<a class="pyv-mobile-view-product" data-pyv-mobile-view-product href="' + escHtml(product.url) + '"' +
        (viewProductNewTab ? ' target="_blank" rel="noopener"' : '') +
        ' aria-label="' + escHtml(viewProductText) + '" title="' + escHtml(viewProductText) + '">' +
        VIEW_PRODUCT_ICON_SVG + '</a>'
      : '';

    var rating = product.rating != null ? parseFloat(product.rating) : NaN;
    var starsHTML = (!isNaN(rating)) ? buildStarsHTML(rating) : '';

    return (
      '<div class="pyv-mobile-info-row"><span class="pyv-mobile-name">' + escHtml(product.title) + '</span><span class="pyv-mobile-stars" data-pyv-mobile-stars>' + starsHTML + '</span></div>' +
      '<div class="pyv-mobile-info-row">' +
        '<span class="pyv-mobile-price-group">' +
          '<span class="pyv-mobile-price">' + escHtml(sv ? sv.price : '') + '</span>' +
          viewProductHTML +
        '</span>' +
        (colors.length ? '<span class="pyv-mobile-swatches">' + swatchesHTML + '</span>' : '') +
      '</div>' +
      '<div class="pyv-mobile-info-row"><span class="pyv-mobile-size-label">' + escHtml(sizeLabel) + '</span>' + sizeGuideHTML + '</div>' +
      (sizePillsHTML ? '<div class="pyv-mobile-sizes">' + sizePillsHTML + '</div>' : '')
    );
  }

  function buildMobileInfoBar(product, opts) {
    var bar = document.createElement('div');
    bar.className = 'pyv-mobile-info';
    bar.innerHTML = buildMobileInfoBarHTML(product, opts);
    return bar;
  }

  function refreshMobileInfoBarSelection(bar, product) {
    if (!bar) return;
    var sv = getSelectedVariant(product);
    var priceEl = bar.querySelector('.pyv-mobile-price');
    if (priceEl) priceEl.textContent = sv ? sv.price : '';
    var curColor = sv && sv.color != null ? String(sv.color).toLowerCase() : '';
    bar.querySelectorAll('.pyv-color-swatch').forEach(function (sw) {
      sw.classList.toggle('is-selected', (sw.dataset.colorName || '').toLowerCase() === curColor && curColor !== '');
    });
    var curSize = sv && sv.size != null ? String(sv.size) : '';
    bar.querySelectorAll('.pyv-size-pill').forEach(function (pill) {
      pill.classList.toggle('is-selected', (pill.dataset.sizeValue || '') === curSize && curSize !== '');
    });
  }

  /* Swap the card image to the selected variant's Shopify-assigned image.
     Called only from the mobile info bar's color-swatch handler — swatches
     never render on desktop, so desktop behaviour is untouched. If the
     variant has no image assigned, the current photo is left as-is. */
  function updateCardVariantImage(bar, product) {
    var card = bar ? bar.closest('.pyv-card') : null;
    if (!card) return;
    var img = card.querySelector('.pyv-card-img');
    if (!img) return;
    var sv = getSelectedVariant(product);
    var src = sv && sv.image ? sv.image : '';
    if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
  }

  function attachMobileInfoListeners(bar, product, onVariantChange) {
    /* View product link: stop the click from bubbling into any card-level
       handler, but let the browser follow the href natively. */
    bar.querySelectorAll('[data-pyv-mobile-view-product]').forEach(function (link) {
      link.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    bar.querySelectorAll('.pyv-color-swatch:not(.is-unavailable)').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var sv = getSelectedVariant(product);
        var newIdx = findVariantIndex(product, sv && sv.size ? sv.size : null, btn.dataset.colorName || '');
        if (newIdx < 0) return;
        product.selectedVariantIdx = newIdx;
        refreshMobileInfoBarSelection(bar, product);
        updateCardVariantImage(bar, product);
        if (typeof onVariantChange === 'function') onVariantChange(getSelectedVariant(product), product);
      });
    });
    bar.querySelectorAll('.pyv-size-pill:not(.is-unavailable)').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var sv = getSelectedVariant(product);
        var newIdx = findVariantIndex(product, btn.dataset.sizeValue || '', sv && sv.color ? sv.color : null);
        if (newIdx < 0) return;
        product.selectedVariantIdx = newIdx;
        refreshMobileInfoBarSelection(bar, product);
        if (typeof onVariantChange === 'function') onVariantChange(getSelectedVariant(product), product);
      });
    });
  }

  function mountMobileRyviu(bar, product) {
    var starsEl = bar ? bar.querySelector('[data-pyv-mobile-stars]') : null;
    if (!starsEl) return;
    var rating = product.rating != null ? parseFloat(product.rating) : NaN;
    starsEl.innerHTML = (!isNaN(rating)) ? buildStarsHTML(rating) : '';
  }

  function updateMobileInfoBar(bar, product, opts) {
    bar.innerHTML = buildMobileInfoBarHTML(product, opts);
    attachMobileInfoListeners(bar, product);
    mountMobileRyviu(bar, product);
  }

  function buildOverlay(kind, product) {
    var sv = getSelectedVariant(product);
    var sizeText = sv && sv.size ? sv.size : '';
    var nameLine = escHtml(product.title);
    var infoLine = sizeText ? nameLine + ' &middot; ' + escHtml(sizeText) : nameLine;
    var iconSvg, titleText, pillText, infoLineText;
    if (kind === 'add') {
      iconSvg = '<svg viewBox="0 0 32 32" fill="none"><path d="M8 12H24L23 25H9L8 12Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M12 12C12 9 13.79 7 16 7C18.21 7 20 9 20 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
      titleText = 'ADD TO CART'; pillText = '<span class="pyv-pill-check" aria-hidden="true">&#10003;</span> Release to confirm';
      infoLineText = '<span class="pyv-overlay-swatch" aria-hidden="true"></span> ' + infoLine;
    } else {
      iconSvg = '<svg viewBox="0 0 32 32" fill="none"><path d="M10 10L22 22M22 10L10 22" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      titleText = 'PASSING'; pillText = 'Release to confirm!';
      infoLineText = '<span class="pyv-overlay-swatch" aria-hidden="true"></span> ' + nameLine + ' &middot; Release to skip';
    }
    var ov = document.createElement('div');
    ov.className = 'pyv-overlay pyv-overlay-' + kind;
    ov.innerHTML =
      '<div class="pyv-overlay-icon" aria-hidden="true">' + iconSvg + '</div>' +
      '<div class="pyv-overlay-title">' + titleText + '</div>' +
      '<div class="pyv-overlay-pill">' + pillText + '</div>' +
      '<div class="pyv-overlay-info">' + infoLineText + '</div>' +
      '<div class="pyv-overlay-data"><span class="pyv-overlay-data-name">' + nameLine + '</span><span class="pyv-overlay-data-price">' + escHtml(sv ? sv.price : '') + '</span></div>';
    return ov;
  }

  function refreshOverlayData(card, product) {
    if (!card) return;
    var sv = getSelectedVariant(product);
    card.querySelectorAll('.pyv-overlay').forEach(function (ov) {
      var name = ov.querySelector('.pyv-overlay-data-name');
      var price = ov.querySelector('.pyv-overlay-data-price');
      if (name) name.textContent = product.title;
      if (price) price.textContent = sv ? sv.price : '';
      var info = ov.querySelector('.pyv-overlay-info');
      if (info) {
        var st = sv && sv.size ? sv.size : '';
        var nl = escHtml(product.title);
        var inner = st ? '<span class="pyv-overlay-swatch" aria-hidden="true"></span> ' + nl + ' &middot; ' + escHtml(st) : '<span class="pyv-overlay-swatch" aria-hidden="true"></span> ' + nl;
        if (ov.classList.contains('pyv-overlay-pass')) inner = '<span class="pyv-overlay-swatch" aria-hidden="true"></span> ' + nl + ' &middot; Release to skip';
        info.innerHTML = inner;
      }
    });
  }

  function buildCard(product, layer, opts) {
    opts = opts || {};
    var isMobile = !!opts.isMobile;
    var isTop = layer === 'top';
    var card = document.createElement('article');
    card.className = 'pyv-card pyv-card-' + layer;
    var frame = document.createElement('div');
    frame.className = 'pyv-card-frame';
    frame.style.background = getCardGradient(product);
    var inner = document.createElement('div');
    inner.className = 'pyv-card-inner';
    if (product.image) {
      var img = document.createElement('img');
      img.className = 'pyv-card-img'; img.src = product.image; img.alt = product.title;
      img.loading = isTop ? 'eager' : 'lazy'; img.decoding = isTop ? 'sync' : 'async'; img.draggable = false;
      inner.appendChild(img);
    } else {
      var ph = document.createElement('div'); ph.className = 'pyv-card-placeholder'; inner.appendChild(ph);
    }
    frame.appendChild(inner);
    if (isMobile) {
      var infoOpts = {
        sizeLabel: opts.sizeLabel,
        sizeGuideText: opts.sizeGuideText,
        sizeGuideUrl: opts.sizeGuideUrl,
        showViewProduct: opts.showViewProduct,
        viewProductText: opts.viewProductText,
        viewProductNewTab: opts.viewProductNewTab
      };
      var bar = buildMobileInfoBar(product, infoOpts);
      frame.appendChild(bar);
      if (isTop) {
        attachMobileInfoListeners(bar, product, function () { refreshOverlayData(card, product); });
      }
    }
    frame.appendChild(buildOverlay('add', product));
    frame.appendChild(buildOverlay('pass', product));
    card.appendChild(frame);
    return card;
  }

  function applyTransform(card, dx, dy) {
    card.style.transform = 'translate(' + dx + 'px, ' + (dy * 0.15) + 'px) rotate(' + (dx / 22) + 'deg)';
  }

  function updateOverlays(card, dx, swipeThreshold) {
    var cw = card.offsetWidth || 1;
    var ratio = Math.min(Math.abs(dx) / ((cw * swipeThreshold) / 100), 1);
    var addOv = card.querySelector('.pyv-overlay-add');
    var passOv = card.querySelector('.pyv-overlay-pass');
    if (dx > 0) { if (addOv) addOv.style.opacity = ratio; if (passOv) passOv.style.opacity = 0; }
    else if (dx < 0) { if (passOv) passOv.style.opacity = ratio; if (addOv) addOv.style.opacity = 0; }
    else { if (addOv) addOv.style.opacity = 0; if (passOv) passOv.style.opacity = 0; }
  }

  function snapBack(card, onAfter) {
    var ao = card.querySelector('.pyv-overlay-add');
    var po = card.querySelector('.pyv-overlay-pass');
    if (ao) ao.style.opacity = 0;
    if (po) po.style.opacity = 0;
    card.style.transition = '';
    void card.offsetHeight;
    card.classList.add('is-snapping');
    card.style.transform = 'translate(0px, 0px)';
    if (typeof onAfter === 'function') onAfter();
    setTimeout(function () { card.classList.remove('is-snapping'); }, 300);
  }

  function attachDrag(card, swipeThreshold, callbacks) {
    callbacks = callbacks || {};
    var startX = 0, startY = 0, dx = 0, dy = 0;
    var dragging = false;
    var committed = false;
    var scrolling = false;
    var pointerId = null;
    var DIRECTION_LOCK_THRESHOLD = 6;

    function getPoint(e) {
      if (e.touches && e.touches[0]) return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      if (e.changedTouches && e.changedTouches[0]) return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
      return { x: e.clientX || 0, y: e.clientY || 0 };
    }

    function isAnimating() { return typeof callbacks.getAnimating === 'function' && callbacks.getAnimating(); }

    function onDown(e) {
      if (isAnimating()) return;
      if (e.target && e.target.closest && (e.target.closest('.pyv-size-pill') || e.target.closest('.pyv-color-swatch') || e.target.closest('.pyv-mobile-size-guide') || e.target.closest('[data-pyv-mobile-view-product]'))) return;
      var pt = getPoint(e);
      startX = pt.x; startY = pt.y;
      dx = 0; dy = 0;
      dragging = true;
      committed = false;
      scrolling = false;
      pointerId = e.pointerId !== undefined ? e.pointerId : null;
      card.style.transition = 'none';
      card.classList.remove('is-snapping');
      /* Do NOT call setPointerCapture here — capturing immediately suppresses
         native scroll on iOS/Android before we know the gesture direction.
         Capture is deferred until horizontal intent is confirmed in onMove. */
    }

    function onMove(e) {
      if (!dragging || isAnimating()) return;
      var pt = getPoint(e);
      var ndx = pt.x - startX;
      var ndy = pt.y - startY;

      /* Wait until the gesture has moved enough to determine direction */
      if (!committed && !scrolling) {
        if (Math.abs(ndx) < DIRECTION_LOCK_THRESHOLD && Math.abs(ndy) < DIRECTION_LOCK_THRESHOLD) return;

        if (Math.abs(ndy) >= Math.abs(ndx)) {
          /* Vertical — hand back to the browser for native scroll */
          scrolling = true;
          dragging = false;
          card.classList.remove('is-dragging');
          /* Release capture if we somehow acquired it */
          if (pointerId !== null && card.releasePointerCapture) {
            try { card.releasePointerCapture(pointerId); } catch (_) {}
            pointerId = null;
          }
          return;
        }

        /* Horizontal intent confirmed — now capture the pointer and take over */
        committed = true;
        card.classList.add('is-dragging');
        if (pointerId !== null && card.setPointerCapture) {
          try { card.setPointerCapture(pointerId); } catch (_) {}
        }
      }

      if (scrolling) return;

      if (e.cancelable !== false) e.preventDefault();

      dx = ndx;
      dy = ndy;
      applyTransform(card, dx, dy);
      updateOverlays(card, dx, swipeThreshold);
      if (typeof callbacks.onMove === 'function') callbacks.onMove(dx);
    }

    function onUp() {
      if (!dragging && !scrolling) return;
      var wasScrolling = scrolling;
      dragging = false;
      scrolling = false;
      card.classList.remove('is-dragging');
      if (pointerId !== null && card.releasePointerCapture) {
        try { card.releasePointerCapture(pointerId); } catch (_) {}
        pointerId = null;
      }
      if (wasScrolling || !committed) return;
      var threshPx = (card.offsetWidth * swipeThreshold) / 100;
      if (dx > threshPx) { if (typeof callbacks.onCommitAdd === 'function') callbacks.onCommitAdd(); }
      else if (dx < -threshPx) { if (typeof callbacks.onCommitPass === 'function') callbacks.onCommitPass(); }
      else { snapBack(card, callbacks.onSnapBack); }
    }

    if (window.PointerEvent) {
      card.addEventListener('pointerdown', onDown);
      card.addEventListener('pointermove', onMove);
      card.addEventListener('pointerup', onUp);
      card.addEventListener('pointercancel', onUp);
    } else {
      card.addEventListener('mousedown', onDown);
      card.addEventListener('touchstart', onDown, { passive: true });
      card.addEventListener('touchmove', onMove, { passive: false });
      card.addEventListener('touchend', onUp);
      card.addEventListener('touchcancel', onUp);
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    }
  }

  window.PYVCard = {
    CARD_GRADIENTS: CARD_GRADIENTS, COLOR_MAP: COLOR_MAP, escHtml: escHtml,
    colorNameToCss: colorNameToCss, getCardGradient: getCardGradient,
    getSelectedVariant: getSelectedVariant, getUniqueSizeVariants: getUniqueSizeVariants,
    getUniqueColorVariants: getUniqueColorVariants, findVariantIndex: findVariantIndex,
    renderSizePills: renderSizePills, buildMobileInfoBarHTML: buildMobileInfoBarHTML,
    buildMobileInfoBar: buildMobileInfoBar, refreshMobileInfoBarSelection: refreshMobileInfoBarSelection,
    attachMobileInfoListeners: attachMobileInfoListeners, mountMobileRyviu: mountMobileRyviu,
    updateMobileInfoBar: updateMobileInfoBar, buildCard: buildCard, buildOverlay: buildOverlay,
    refreshOverlayData: refreshOverlayData, applyTransform: applyTransform,
    updateOverlays: updateOverlays, snapBack: snapBack, attachDrag: attachDrag,
    buildStarsHTML: buildStarsHTML, VIEW_PRODUCT_ICON_SVG: VIEW_PRODUCT_ICON_SVG
  };

})();